export default {
  // Component Alert
  Alert: {
    ariaDescribedby: 'aria-describedby',
    ariaLabelledby: 'aria-labelledby'
  },
  // Component: Accordion
  Accordion: {
    isBordered: 'hasBorder'
  },
  // Component: Accordion.Item
  'Accordion.Item': {
    isBordered: 'hasBorder'
  },
  // Component: Box
  Box: {
    isBordered: 'hasBorder'
  },
  // Component Button
  Button: {
    ariaLabel: 'aria-label'
  },
  // Component ButtonGroup
  ButtonGroup: {
    ariaLabel: 'aria-label'
  },
  // Component Callout
  Callout: {
    type: 'variant'
  },
  // Component: DefinitionListTable
  DefinitionListTable: {
    isBorderless: function isBorderless(value) {
      if (value !== null) {
        return {
          hasBorder: !value
        };
      }
      return null;
    }
  },
  // Component Dropdown
  Dropdown: {
    ariaLabel: 'aria-label'
  },
  // Component FilePicker
  FilePicker: {
    ariaDescribedBy: 'aria-describedby'
  },
  // Component FormOption
  FormOption: {
    ariaLabel: 'aria-label'
  },
  // Component LegacyButton
  LegacyButton: {
    ariaLabel: 'aria-label'
  },
  // Component Link
  Link: {
    ariaLabel: 'aria-label',
    ariaLabelledby: 'aria-labelledby'
  },
  // Component Masthead
  Masthead: {
    ariaLabel: 'aria-label'
  },
  // Component Menu
  Menu: {
    ariaLabel: 'aria-label'
  },
  // Component Menu.Link
  'Menu.Link': {
    ariaLabel: 'aria-label'
  },
  // Component MultiSelect
  MultiSelect: {
    ariaLabel: 'aria-label'
  },
  // Component Pagination
  Pagination: {
    ariaLabel: 'aria-label'
  },
  // Component: SelectablePanel
  SelectablePanel: {
    isBordered: 'hasBorder'
  },
  // Component: SelectablePanelGroup
  SelectablePanelGroup: {
    isBordered: 'hasBorder'
  },
  // Component: Slab
  Slab: {
    hasArrow: 'hasActionIcon',
    text: 'title'
  },
  // Component: Slider
  Slider: {
    ariaLabel: 'aria-label'
  },
  // Component: Switch
  Switch: {
    ariaLabel: 'aria-label',
    ariaDescribedBy: 'aria-describedby'
  },
  // Component SwitchGroup
  SwitchGroup: {
    ariaLabel: 'aria-label'
  },
  // Component: Table
  Table: {
    isBorderless: function isBorderless(value) {
      if (value !== null) {
        return {
          hasBorder: !value
        };
      }
      return null;
    }
  },
  // Component: Tabs
  Tabs: {
    bordered: 'hasBorder'
  },
  // Component: Tile
  Tile: {
    isBordered: 'hasBorder'
  },
  // Component: Tile.Head
  'Tile.Head': {
    isBordered: 'hasBorder'
  },
  // Component: Tile.Body
  'Tile.Body': {
    isBordered: 'hasBorder'
  },
  // Component VehicleImage
  VehicleImage: {
    ariaLabelledby: 'aria-labelledby'
  }
};